// extracted by mini-css-extract-plugin
export default {"header__right-group__button":"ToggleSideMenu_header__right-group__button__dNEls","header__right-group__overlay":"ToggleSideMenu_header__right-group__overlay__Wu3Wu"};